<template>
    <div class="container-fluid">
        <div class="not-found-card">
            <div class="not-found-header">
                <div class="text-center">
                    <div class="error-code-large">{{ $t('notFound.errorCode') }}</div>
                    <h1 class="error-title">{{ $t('notFound.title') }}</h1>
                </div>
            </div>
            
            <div class="not-found-content">
                <div class="text-center mb-4">
                    <p class="error-description">
                        {{ $t('notFound.description') }}
                    </p>
                </div>
                
                <div v-if="cameFrom" class="came-from-box mb-4">
                    <div class="came-from-label mb-2">
                        <strong>{{ $t('notFound.cameFromLabel') }}</strong>
                    </div>
                    <a :href="fullCameFromUrl" class="came-from-link">
                        {{ fullCameFromUrl }}
                    </a>
                </div>
                
                <div class="text-center action-section">
                    <p class="help-text mb-3">
                        {{ $t('notFound.helpText') }}
                    </p>
                    <a :href="supportLink()" class="btn btn-cta btn-lg">
                        {{ $t('notFound.supportButton') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'NotFound',
    data() {
        return {
            cameFrom: this.$route.params.cameFrom || ''
        }
    },
    computed: {
        fullCameFromUrl() {
            if (!this.cameFrom) return '';
            return `${window.location.origin}${this.cameFrom}`;
        }
    },
    methods: {
        supportLink() {
            const email = 'technik@gfu.net';
            const subject = this.$t('notFound.emailSubject');
            
            let body = this.$t('notFound.emailBody.greeting') + '\n\n';
            body += this.$t('notFound.emailBody.problem') + '\n\n';
            
            if (this.cameFrom && this.cameFrom.trim() !== '') {
                const fullUrl = `${window.location.origin}${this.cameFrom}`;
                body += this.$t('notFound.emailBody.linkLabel') + '\n' + fullUrl + '\n\n';
            }
            
            body += this.$t('notFound.emailBody.closing') + '\n\n';
            body += this.$t('notFound.emailBody.regards');
            
            return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        }
    }
}
</script>

<style scoped>
.not-found-card {
    background: white;
    border-radius: 5px;
    margin-bottom: 40px;
}

.not-found-header {
    padding: 3rem 2rem 2rem;
    border-bottom: 1px solid #e6ebf2;
}

.error-code-large {
    font-size: 6rem;
    font-weight: 700;
    color: #033878;
    line-height: 1;
    margin-bottom: 1rem;
}

.error-title {
    font-size: 1.75rem;
    font-weight: 500;
    color: #033878;
    margin: 0;
}

.not-found-content {
    padding: 2rem;
}

.error-description {
    font-size: 1.1rem;
    color: #033878;
    line-height: 1.6;
}

.came-from-box {
    background: #f1f8f7;
    border-left: 4px solid #fdc41f;
    padding: 1.5rem;
    border-radius: 10px;
    text-align: left;
}

.came-from-label {
    font-size: 0.95rem;
    color: #033878;
}

.came-from-link {
    display: block;
    color: #042b60;
    text-decoration: none;
    word-break: break-all;
    font-size: 0.9rem;
    padding: 0.75rem;
    background: white;
    border-radius: 8px;
    transition: all 0.3s ease;
    margin-top: 0.5rem;
}

.came-from-link:hover {
    background: #e8f4f8;
    color: #042b60;
    text-decoration: underline;
}

.action-section {
    padding-top: 2rem;
    border-top: 1px solid #e6ebf2;
}

.help-text {
    color: #033878;
    font-size: 1rem;
}

@media (max-width: 768px) {
    .not-found-header {
        padding: 2rem 1.5rem 1.5rem;
    }
    
    .not-found-content {
        padding: 1.5rem;
    }
    
    .error-code-large {
        font-size: 4rem;
    }
    
    .error-title {
        font-size: 1.35rem;
    }
    
    .error-description {
        font-size: 1rem;
    }
    
    .came-from-box {
        padding: 1rem;
    }
}
</style>
